const env = Object.freeze({
    environment: process.env.REACT_APP_ENV,
    isProduction: process.env.REACT_APP_ENV === 'production',
    apiUrl: process.env.REACT_APP_API_URL,
    appName: process.env.REACT_APP_APPNAME || 'Uchann',
});

export default env
